import { useEffect, useState } from 'react';
import styles from './app.module.scss';
import Form from './components/form/Form';
import Header from './components/header/Header';
import MessageError from './components/messageError/MessageError';
import WaitingMessage from './components/waintingMessage/WaintingMessage';
import { queriesParser } from './tools';

const API_URL = process.env.REACT_APP_API_URL;
const URBANEASE_URL = process.env.REACT_APP_URBANEASE_URL!;

function App() {
  const [display, setDisplay] = useState<Display>('form');
  const [queries, setQueries] = useState<UrlQueries>(null);

  useEffect(() => {
    // get queries from url
    const queries = queriesParser();

    // if all queries, set state else return to uranease
    if (queries) {
      setQueries(queries);
    } else {
      setDisplay('queryError');
    }
  }, []);

  const postNewPassword = async (datas: Omit<FormType, 'passwordConfirm'>) => {
    const body = {
      password: datas.newPassword,
      email: datas.reference,
      token: queries?.token ?? '',
    };
    try {
      setDisplay('waiting');

      const result = await fetch(`${API_URL}/reset_password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (result.status >= 400) {
        setDisplay('postError');
      } else {
        // add query to force logout on urbanease app
        window.location.href = URBANEASE_URL + '?new_password_generated=true';
      }
    } catch (error: any) {
      setDisplay('postError');
    }
  };

  return (
    <main className={styles.main}>
      <Header />

      <div className={styles.bodyWrapper}>
        <div className={styles.passwordHeader}>
          <h2>Changement de mot de passe Urbanease</h2>
          {display === 'form' ? (
            <p>Le mot de passe associé à l'email ci-dessous sera remplacé.</p>
          ) : null}
        </div>

        {display === 'form' ? (
          <Form onValid={postNewPassword} queries={queries} />
        ) : null}

        <WaitingMessage display={display} />

        <MessageError errorType={display} />
      </div>
    </main>
  );
}

export default App;
